import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';
import { selectCurrentServiceId } from '../../../../store/person/person.selectors';

@Injectable()
export class NursingCareAssessmentUpsertDialogStore extends ComponentStoreV2Factory {

    public serviceId = toSignal(globalStore!.select(selectCurrentServiceId));
    
}
